import React from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { CircularProgress } from '@mui/material';
import styles from '../../styles/component.module.scss';
import TableComponent from '../TableComponent';
import CostAnalysisTableFields from './TableFields/CostAnalysisTableFields';

const TABLE_TITLE = "AI Cost Tracking";
const selectedRows = [];
const setSelectedRows = () => {};
const handleRowClick = () => {};

const CostAnalysisTable = ({ 
    costAnalysisUsageInfo, 
    pagination, 
    loading, 
    error,
    paginationModel,
    onPaginationModelChange,
    tableHeight = "100%",
    onDownloadCSV,
    downloadingCSV = false,
    isOrganizationSelected = false
}) => {    
    // Filter out any invalid/null rows to prevent errors
    const rows = loading || !costAnalysisUsageInfo 
        ? [] 
        : costAnalysisUsageInfo.filter(row => row != null && typeof row === 'object');
    const rowCount = pagination?.totalRecords || 0;

    // Header action buttons
    const headerActionButtons = [
        {
            name: "Download CSV",
            tooltip: isOrganizationSelected 
                ? (downloadingCSV ? 'Downloading CSV file...' : 'Download cost tracking data as CSV')
                : 'Please select an organization to download CSV',
            icon: downloadingCSV 
                ? <CircularProgress size={18} thickness={4} sx={{ color: 'inherit' }} />
                : <ArrowDownTrayIcon className="icon" style={{ width: 18, height: 18 }} />,
            action: onDownloadCSV || (() => {}),
            disabled: !isOrganizationSelected || downloadingCSV || loading,
            section: 'right',
            contained: false,
            fullbutton: true
        }
    ];
    
    return (
        <TableComponent
            viewType="AICostTracking"
            title={TABLE_TITLE}
            hideColumnsVisibilityButton
            headerActionButtons={headerActionButtons}
            rows={rows}
            columns={CostAnalysisTableFields()}
            loading={loading}
            idField="id"
            isColumnResizable={!loading}
            isRowSelection
            handleRowSelection={setSelectedRows}
            selectedRows={selectedRows}
            handleRowClick={handleRowClick}
            isPagination={true}
            paginationMode="server"
            rowCount={rowCount}
            paginationModel={paginationModel}
            handlePaginationModelChange={onPaginationModelChange}
            rowsPerPageOptions={[25, 50, 100]}
            tableHeight={tableHeight}
        />
    );
};

export default CostAnalysisTable;